import { render, staticRenderFns } from "./ProductContentAssignments.vue?vue&type=template&id=0f66deb2&scoped=true&"
import script from "./ProductContentAssignments.vue?vue&type=script&lang=js&"
export * from "./ProductContentAssignments.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentAssignments.vue?vue&type=style&index=0&id=0f66deb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66deb2",
  null
  
)

export default component.exports